import React from 'react';
import { useProgressDisplayStore } from '../../stores/progressDisplayStore';

/** Maps the user's reveal-style preference to its CSS keyframe (see index.css). */
export const XP_KEYFRAME: Record<string, string> = {
  slide: 'xp-fly',
  rise: 'xp-rise',
  pop: 'xp-pop',
};

interface XpChipProps {
  amount: number;
  /** Increments per gain — used as `key` so the animation restarts each time. */
  token: number;
  color?: string | null;
  /** Positioning classes for the absolutely-placed wrapper. */
  className?: string;
}

/**
 * The "+N XP" chip, shared across the desktop reward surfaces. Absolutely
 * positioned by the caller; reveals with the user's chosen animation style.
 */
export function XpChip({ amount, token, color, className = '' }: XpChipProps) {
  const xpStyle = useProgressDisplayStore((s) => s.xpStyle);
  if (!(amount > 0)) return null;

  const animation = `${XP_KEYFRAME[xpStyle] || 'xp-fly'} 1100ms ease-out forwards`;
  return (
    <span key={token} className={`pointer-events-none absolute z-20 ${className}`}>
      <span
        className="xp-chip block whitespace-nowrap text-xs font-semibold italic"
        style={{ color: color || 'rgb(var(--primary))', animation }}
      >
        +{amount} XP
      </span>
    </span>
  );
}
